// import React, { useState } from "react";
// import "./OnboardingEmployees.css";

// import {
//   Box,
//   Button,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Paper,
//   Checkbox,
//   Modal,
//   TextField,
//   IconButton,
// } from "@mui/material";

// import VisibilityIcon from "@mui/icons-material/Visibility";
// import CloseIcon from "@mui/icons-material/Close";
// import AddIcon from "@mui/icons-material/Add";

// const initialForm = {
//   jobTitle: "",
//   candidateId: "",
//   candidateName: "",
//   contactNumber: "",
//   emailId: "",
//   serviceCommitment: "",
//   serviceBreakAmount: "",
//   ctc: "",
//   dateOfJoining: "",
//   status: "Pending",
// };

// const OnboardingEmployees = () => {
//   const [employees, setEmployees] = useState([]);
//   const [openAdd, setOpenAdd] = useState(false);
//   const [openView, setOpenView] = useState(false);
//   const [form, setForm] = useState(initialForm);
//   const [viewData, setViewData] = useState(null);

//   const handleAdd = () => {
//     setEmployees([...employees, { ...form, id: Date.now() }]);
//     setForm(initialForm);
//     setOpenAdd(false);
//   };

//   const handleView = (row) => {
//     setViewData(row);
//     setOpenView(true);
//   };

//   return (
//     <Box className="onboarding-wrapper">
//       {/* HEADER */}
//       <Box className="onboarding-header">
//         <h2>Employee Onboarding</h2>
//         <Button
//           startIcon={<AddIcon />}
//           className="btn-primary"
//           onClick={() => setOpenAdd(true)}
//         >
//           Add Employee
//         </Button>
//       </Box>

//       {/* TABLE */}
//       <Paper className="table-wrapper">
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell />
//               <TableCell>S.NO</TableCell>
//               <TableCell>Job Title / Designation</TableCell>
//               <TableCell>Candidate Id</TableCell>
//               <TableCell>Candidate Name</TableCell>
//               <TableCell>Contact Number</TableCell>
//               <TableCell>Email Id</TableCell>
//               <TableCell>Service Commitment (Years)</TableCell>
//               <TableCell>Service Break Amount</TableCell>
//               <TableCell>CTC (INR)</TableCell>
//               <TableCell>Status</TableCell>
//               <TableCell>Action</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {employees.length === 0 ? (
//               <TableRow>
//                 <TableCell colSpan={12} align="center">
//                   No records found
//                 </TableCell>
//               </TableRow>
//             ) : (
//               employees.map((emp, index) => (
//                 <TableRow key={emp.id}>
//                   <TableCell>
//                     <Checkbox size="small" />
//                   </TableCell>
//                   <TableCell>{index + 1}</TableCell>
//                   <TableCell>{emp.jobTitle}</TableCell>
//                   <TableCell>{emp.candidateId}</TableCell>
//                   <TableCell>{emp.candidateName}</TableCell>
//                   <TableCell>{emp.contactNumber}</TableCell>
//                   <TableCell>{emp.emailId}</TableCell>
//                   <TableCell>{emp.serviceCommitment}</TableCell>
//                   <TableCell>{emp.serviceBreakAmount}</TableCell>
//                   <TableCell>₹ {emp.ctc}</TableCell>
//                   <TableCell>
//                     <span className="status pending">{emp.status}</span>
//                   </TableCell>
//                   <TableCell>
//                     <IconButton
//                       color="primary"
//                       onClick={() => handleView(emp)}
//                     >
//                       <VisibilityIcon />
//                     </IconButton>
//                   </TableCell>
//                 </TableRow>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </Paper>

//       {/* ADD POPUP */}
//       <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
//         <Box className="modal-box">
//           <h3>Add Onboarding Employee</h3>

//           <div className="form-grid">
//             {Object.keys(initialForm).map((key) =>
//               key !== "status" ? (
//                 <TextField
//                   key={key}
//                   label={key.replace(/([A-Z])/g, " $1")}
//                   type={key === "dateOfJoining" ? "date" : "text"}
//                   InputLabelProps={
//                     key === "dateOfJoining" ? { shrink: true } : {}
//                   }
//                   value={form[key]}
//                   onChange={(e) =>
//                     setForm({ ...form, [key]: e.target.value })
//                   }
//                 />
//               ) : null
//             )}
//           </div>

//           <div className="modal-footer">
//             <Button onClick={() => setOpenAdd(false)}>Cancel</Button>
//             <Button className="btn-primary" onClick={handleAdd}>
//               Save
//             </Button>
//           </div>
//         </Box>
//       </Modal>

//       {/* VIEW POPUP */}
//       <Modal open={openView} onClose={() => setOpenView(false)}>
//         <Box className="modal-box">
//           <Box className="modal-header">
//             <h3>Employee Details</h3>
//             <IconButton onClick={() => setOpenView(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>

//           {viewData && (
//             <div className="view-grid">
//               <p><b>Job Title:</b> {viewData.jobTitle}</p>
//               <p><b>Candidate Id:</b> {viewData.candidateId}</p>
//               <p><b>Name:</b> {viewData.candidateName}</p>
//               <p><b>Contact:</b> {viewData.contactNumber}</p>
//               <p><b>Email:</b> {viewData.emailId}</p>
//               <p><b>Service Commitment:</b> {viewData.serviceCommitment} Years</p>
//               <p><b>Service Break Amount:</b> ₹ {viewData.serviceBreakAmount}</p>
//               <p><b>Date of Joining:</b> {viewData.dateOfJoining}</p>
//               <p><b>CTC:</b> ₹ {viewData.ctc}</p>
//               <p><b>Status:</b> {viewData.status}</p>
//             </div>
//           )}
//         </Box>
//       </Modal>
//     </Box>
//   );
// };

// export default OnboardingEmployees;




import React, { useState } from "react";
import "./OnboardingEmployees.css";
import {
  Box,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Checkbox,
  Modal,
  TextField,
  IconButton,
  MenuItem,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";

const initialForm = {
  jobTitle: "",
  candidateId: "",
  candidateName: "",
  contactNumber: "",
  emailId: "",
  serviceCommitment: "",
  serviceBreakAmount: "",
  ctc: "",
  dateOfJoining: "",
  status: "Pending",
};

const fieldLabels = {
  jobTitle: "Job Title / Designation",
  candidateId: "Candidate ID",
  candidateName: "Candidate Name",
  contactNumber: "Contact Number",
  emailId: "Email ID",
  serviceCommitment: "Service Commitment (Years)",
  serviceBreakAmount: "Service Break Amount",
  ctc: "CTC (INR)",
  dateOfJoining: "Date of Joining",
};

const months = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December"
];

const OnboardingEmployees = () => {
  const [employees, setEmployees] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [form, setForm] = useState(initialForm);
  const [viewData, setViewData] = useState(null);

  const [filterYear, setFilterYear] = useState("");
  const [filterMonth, setFilterMonth] = useState("");

  const handleAdd = () => {
    // Basic validation
    if (!form.jobTitle || !form.candidateName || !form.emailId) {
      alert("Please fill Job Title, Candidate Name, and Email");
      return;
    }
    setEmployees([...employees, { ...form, id: Date.now() }]);
    setForm(initialForm);
    setOpenAdd(false);
  };

  const handleView = (row) => {
    setViewData(row);
    setOpenView(true);
  };

  const filteredEmployees = employees.filter((emp) => {
    if (!emp.dateOfJoining) return true;
    const date = new Date(emp.dateOfJoining);
    const yearMatch = filterYear ? date.getFullYear().toString() === filterYear : true;
    const monthMatch = filterMonth ? date.getMonth() === Number(filterMonth) : true;
    return yearMatch && monthMatch;
  });

  return (
    <Box className="onboarding-wrapper">

      {/* HEADER */}
      <Box className="onboarding-header">
        <h2>Employee Onboarding</h2>

        <Box className="header-right">
          <TextField
            select
            size="small"
            label="Year"
            value={filterYear}
            onChange={(e) => setFilterYear(e.target.value)}
          >
            <MenuItem value="">All</MenuItem>
            {[2024, 2025, 2026].map((y) => (
              <MenuItem key={y} value={y}>{y}</MenuItem>
            ))}
          </TextField>

          <TextField
            select
            size="small"
            label="Month"
            value={filterMonth}
            onChange={(e) => setFilterMonth(e.target.value)}
          >
            <MenuItem value="">All</MenuItem>
            {months.map((m, i) => (
              <MenuItem key={i} value={i}>{m}</MenuItem>
            ))}
          </TextField>

          <Button
            startIcon={<AddIcon />}
            className="btn-primary"
            onClick={() => setOpenAdd(true)}
          >
            Add Employee
          </Button>
        </Box>
      </Box>

      {/* TABLE */}
      <Paper className="table-wrapper">
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>S.No</TableCell>
              <TableCell>Job Title / Designation</TableCell>
              <TableCell>Candidate ID</TableCell>
              <TableCell>Candidate Name</TableCell>
              <TableCell>Contact Number</TableCell>
              <TableCell>Email ID</TableCell>
              <TableCell>Service Commitment</TableCell>
              <TableCell>Service Break Amount</TableCell>
              <TableCell>CTC (INR)</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredEmployees.length === 0 ? (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  No records found
                </TableCell>
              </TableRow>
            ) : (
              filteredEmployees.map((emp, index) => (
                <TableRow key={emp.id}>
                  <TableCell><Checkbox size="small" /></TableCell>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{emp.jobTitle}</TableCell>
                  <TableCell>{emp.candidateId}</TableCell>
                  <TableCell>{emp.candidateName}</TableCell>
                  <TableCell>{emp.contactNumber}</TableCell>
                  <TableCell>{emp.emailId}</TableCell>
                  <TableCell>{emp.serviceCommitment}</TableCell>
                  <TableCell>₹ {emp.serviceBreakAmount}</TableCell>
                  <TableCell>₹ {emp.ctc}</TableCell>
                  <TableCell>
                    <span className="status pending">{emp.status}</span>
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleView(emp)}>
                      <VisibilityIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Paper>

      {/* ADD EMPLOYEE MODAL */}
      <Modal open={openAdd} onClose={() => setOpenAdd(false)}>
        <Box className="modal-box">
          <div className="modal-header">
            <h3>Add Employee</h3>
            <IconButton onClick={() => setOpenAdd(false)}>
              <CloseIcon />
            </IconButton>
          </div>

          <div className="add-form-grid">
            {Object.keys(fieldLabels).map((key) => (
              <TextField
                key={key}
                label={fieldLabels[key]}
                size="small"
                type={key === "dateOfJoining" ? "date" : "text"}
                value={form[key]}
                onChange={(e) => setForm({ ...form, [key]: e.target.value })}
                InputLabelProps={key === "dateOfJoining" ? { shrink: true } : {}}
                fullWidth
                margin="dense"
              />
            ))}
          </div>

          <Box mt={2} display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              color="primary"
              onClick={handleAdd}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* VIEW MODAL */}
      <Modal open={openView} onClose={() => setOpenView(false)}>
        <Box className="modal-box">
          <div className="modal-header">
            <h3>Employee Details</h3>
            <IconButton onClick={() => setOpenView(false)}>
              <CloseIcon />
            </IconButton>
          </div>

          {viewData && (
            <div className="view-grid">
              {Object.keys(fieldLabels).map((key) => (
                <div key={key}>
                  <span>{fieldLabels[key]}</span>
                  <p>{viewData[key]}</p>
                </div>
              ))}
            </div>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default OnboardingEmployees;
